import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class PaymentStatusService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

   /**
   * Fetch customs payment statuses.
   */
   fetchPaymentStatuses(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/payment-status`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }
}
